module.exports = __webpack_public_path__ + "components/flag/static/square/bq-94ea273d0493ff8e32ada1391c693e68.svg";